import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { spdrUrls } from "../../../URL/ApplicationUrls";
import { Spdr } from "../Spdr";
import { updateSuccessMessage } from "../../../Messages/successMessages";
import { MdmApiError } from "../../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../../Errors/apiErrorNotificationToast";

export const useUpdateSpdr = (spdrId: number | string | undefined) => {
  return useMutation({
    mutationFn: async (spdr: Spdr) => {
      await axios.put(spdrUrls.spdrWithId(spdrId).apiUrl, spdr);
    },
    onSuccess: async () => {
      toast.success(updateSuccessMessage(spdrId, "SPDR"));
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
